import React from "react";
import { Avatar } from "./style";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../_store/_actions/repositoryUserActions";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Menu, MenuItem, MenuButton, MenuDivider } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";

const AvatarUser = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userName } = useSelector((state) => state.repository.user);
  const { redirectOn } = useSelector((state) => state.repository);
  const { urlSource } = useSelector((state) => state.repository.partner);

  const handleLogout = () => {
    if (redirectOn === null || redirectOn !== true) {
      sessionStorage.removeItem("token_security");
      window.location.href = urlSource;
      return null;
    } else {
      dispatch(userLogout());
      return <Redirect to="/" />;
    }
  };

  const handleMenuProfile = () => {
    history.push("/profile");
  };

  const handleMenuDashboard = () => {
    history.push("/ata");
  };

  const navDropdownTitle = <div href="#" className="user-img"></div>;

  return (
    <>
      <Avatar className="nomargin nopadding">
        <Menu menuButton={navDropdownTitle}>
          <MenuItem onClick={handleMenuProfile}>User profile</MenuItem>
          <MenuDivider />
          <MenuItem onClick={handleLogout}>Log Out</MenuItem>
        </Menu>
      </Avatar>
    </>
  );
};

export default AvatarUser;
